import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/AxiosInstance.jsx';
import { handlePromise } from '../utils';

const useTrainings = () => {
  return useQuery({
    queryKey: ['trainings'],
    queryFn: () => handlePromise(axiosInstance.get('/internal_api/training/all')),
    staleTime: Infinity,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
};
const useTrainingById = (id) => {
  return useQuery({
    queryKey: ['training', id],
    queryFn: () => handlePromise(axiosInstance.get(`/internal_api/training/${id}`)),
    staleTime: Infinity,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: !!id,
  });
};
const useTrainingInfoById = (id) => {
  return useQuery({
    queryKey: ['training', id, 'info'],
    queryFn: () =>
      handlePromise(axiosInstance.get(`/internal_api/tunnel/training-tunnel-information?training_id=${id}`)),
    staleTime: Infinity,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: !!id,
  });
};

const useTrainingSteps = (id) => {
  return useQuery({
    queryKey: ['training', id, 'steps'],
    queryFn: () => handlePromise(axiosInstance.get(`/internal_api/tunnel/${id}/get-training-current-status`)),
    staleTime: Infinity,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: !!id,
  });
};

export { useTrainings, useTrainingById, useTrainingInfoById, useTrainingSteps };
